import { AcadNavTabs } from "@components";
import routes from "./AcademyRoutes";

const Academy = () => {
  return <AcadNavTabs routes={routes} />;
};

export default Academy;
